import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GroupService } from 'src/app/group/group.service';
import { Frequency } from '../interfaces/Frequency';
import { FrequencyService } from '../services/frequency.service';
import { Location } from '@angular/common';
import { FrequencyPending } from '../interfaces/freuencyPending';
import { Pagination } from 'src/app/shared/interfaces/pagination.interface';

@Component({
  selector: 'app-frequency-list',
  templateUrl: './frequency-list.component.html',
  styleUrls: ['./frequency-list.component.css'],
})
export class FrequencyListComponent implements OnInit {
  frequencies: Frequency[] = [];
  frequenciesPending: FrequencyPending[];
  groups: any[] = [];
  pagination: Pagination = {
    page: 0,
    limit: 10,
    lastPage: 0,
  };

  constructor(
    private frequencyService: FrequencyService,
    private groupService: GroupService,
    private toast: ToastrService,
    private _location: Location
  ) {
    this.getFrequencies(this.pagination);
    this.getFrequenciesPending();
  }

  ngOnInit(): void {}

  getGroups(): Promise<any> {
    return this.groupService.get().then((res) => {
      this.groups = res;
      if (res.length > 0) {
        this.groupChange(this.groups[0].id);
      }
    });
  }

  groupChange(id) {
    this.frequencies = [];
    this.frequencyService.getFrequenciesByGroupId(id).then((res) => {
      this.frequencies = res;
    });
  }

  renderedRangeStream(a) {
    console.log('range stream', a);
  }

  async scroll(event) {
    console.log('log', this.frequencies.length);

    console.log(event);

    if (
      event == this.frequencies.length - 1 &&
      this.frequencies.length !== 0 &&
      this.pagination.page < this.pagination.lastPage
    ) {
      this.pagination.page++;
      this.getFrequencies(this.pagination);
    }
  }

  getFrequencies(pagination) {
    return this.frequencyService
      .get(pagination)
      .then((res) => {
        console.log(res);

        this.frequencies = this.frequencies.concat(res.data);
        this.pagination.lastPage = res?.lastPage;
      })
      .catch((err) => {
        console.log(err);

        this.toast.error(err.error.message);
      });
  }

  getFrequenciesPending() {
    return this.frequencyService
      .getPendingFrequencies()
      .then((res) => {
        this.frequenciesPending = res;
      })
      .catch((err) => {
        this.toast.error(err.error.message);
      });
  }
}
